export enum CarouselModel {
    BRAND_A_TO_Z = 'brandAtoZ',
    BRAND_TRENDING = 'brandTrending',
    BRANDS = 'brands',
    CHANNEL = 'channel',
    CHARACTER = 'characterCarousel',
    DISPLAY_AD_BANNER = 'displayAdBanner',
    DISPLAY_CREATIVE = 'displayCreative',
    GRID = 'grid',
    HOMESHOWGROUP = 'homeShowGroup',
    HYBRID = 'showMovieHybrid',
    KEEP_WATCHING = 'keepWatching',
    MOVIE = 'movie',
    MULTI_CHANNEL_COLLECTION = 'multi-channel-collection',
    ONNOW = 'onnow',
    PROMINENT = 'prominent',
    PROMOTION = 'promotion',
    RECENT_CHANNELS = 'recentChannels',
    RECOMMENDATION = 'recommendation',
    SCHEDULE = 'schedule',
    SHOW = 'show',
    TRENDING = 'trending',
    UNIVERSAL_CONTENT = 'universalContent',
    VIDEO = 'video',
    VIDEO_CONFIG = 'videoConfig',
    WATCHAGAIN = 'watchAgain',
    WATCH_LIST_CHANNELS = 'watchListChannels',
}
